import { action } from 'typesafe-actions';

import {
  ISearchActionTypes,
  ISearchParams,
  ITimeFilters,
  SearchResponse,
} from './Types';

export const launchSearch = (params: ISearchParams) => action(ISearchActionTypes.LAUNCH_SEARCH, params);
export const launchSearchSuccess = (results: SearchResponse) => action(ISearchActionTypes.LAUNCH_SEARCH_SUCCESS, results);
export const launchSearchError = (err: string) =>
  action(ISearchActionTypes.LAUNCH_SEARCH_ERROR, err);

export const paginateSearch = (page: number, limit: number) => action(ISearchActionTypes.PAGINATE_SEARCH, [page, limit]);
export const paginateSearchSuccess = (results: SearchResponse) => action(ISearchActionTypes.PAGINATE_SEARCH_SUCCESS, results);
export const paginateSearchError = (err: string) =>
  action(ISearchActionTypes.PAGINATE_SEARCH_ERROR, err);

export const searchReinitParams = () =>
  action(ISearchActionTypes.SEARCH_REINIT_PARAMS);
export const saveTimeFilters = (filters: ITimeFilters) =>
  action(ISearchActionTypes.SAVE_TIME_SELECTION, filters);